import { useTheme } from '@pata-app/themes';

import React, { useEffect, useMemo, useState } from 'react';

import AutoComplete from '../../../../../../../components/autoComplete/autoComplete';
import Icon from '../../../../../../../components/icon/icon';
import { NewIcon } from '../../../../../../../components/newIcon/icon';
import PlacesAutoComplete from '../../../../../../../components/placeAutoComplete/placesAutoComplete';
import useSearchTermPrediction from '../../../../../../../hooks/useSearchTermPredictions';
import { CurrentLocation, SearchInputsWrapper, SearchInputWrapper } from './searchInputs.styled';

interface ISearchInput {
  searchTerm: string;
  location: string;
  onChange: (field: string, value: any) => void;
}

const SearchInputs = ({ searchTerm, location, onChange }: ISearchInput) => {
  const theme = useTheme();

  const [isFetchingLocation, setIsFetchingLocation] = useState(false);

  const { predictions, onInputChange } = useSearchTermPrediction();

  const termValueLabel = useMemo(() => {
    return predictions.find((prediction) => prediction.sid === searchTerm)?.name;
  }, [predictions, searchTerm]);

  useEffect(() => {
    onInputChange(searchTerm);
  }, []);

  const handleLocationChange = (lat: number, lng: number, name?: string, locationType?: any) => {
    onChange('location', { lat, lng, name, locationType });
  };

  const handleSelect = (option: any) => {
    onChange('searchTerm', { name: option.sid || option.name, type: option.group });

    onInputChange(option.name);
  };

  const handleInputChange = (searchValue: string) => {
    onInputChange(searchValue);

    if (!searchValue) {
      onChange('searchTerm', { name: undefined });
    } else {
      onChange('searchTerm', { name: searchValue, type: 'name' });
    }
  };

  const handleUseCurrentLocation = () => {
    setIsFetchingLocation(true);

    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };

    const success = (pos: any) => {
      const crd = pos.coords;

      handleLocationChange(crd.latitude, crd.longitude);
      setIsFetchingLocation(false);
    };

    const error = (err: any) => {
      console.warn(`ERROR(${err.code}): ${err.message}`);
      setIsFetchingLocation(false);
    };

    navigator.geolocation.getCurrentPosition(success, error, options);
  };

  return (
    <SearchInputsWrapper>
      <SearchInputWrapper>
        <AutoComplete
          placeholder="Search services or businesses"
          value={termValueLabel}
          predictions={predictions}
          onSelect={handleSelect}
          onInputChange={handleInputChange}
          allowFreeText
          groupKey="group"
          freeSearchDescription="Business name"
        />
        <NewIcon type="Search" size="18px" fill={theme.core.colors.primary.green.medium} />
      </SearchInputWrapper>

      <SearchInputWrapper>
        <PlacesAutoComplete placeValue={location !== 'null' ? location : ''} onPlaceSelected={handleLocationChange} />
        <NewIcon type="Pin" size="20px" fill={theme.core.colors.primary.green.medium} />
        <CurrentLocation
          isFetchingLocation={isFetchingLocation}
          onClick={handleUseCurrentLocation}
          aria-label="Use current location"
        >
          {/* <Icon
            type={isFetchingLocation ? 'Loader' : 'CurrentLocation'}
            fill={theme.core.colors.primary.green.medium}
            size={isFetchingLocation ? '40px' : '20px'}
          /> */}
        </CurrentLocation>
      </SearchInputWrapper>
    </SearchInputsWrapper>
  );
};

export default SearchInputs;
